export class EditorConfigConstants {
  static readonly FONT_NAME: string = "fontName";
  static readonly CUSTOM_CLASSES: string = "customClasses";
  static readonly LINK: string = "link";
  static readonly UNLINK: string = "unlink";
  static readonly INSERT_IMG: string = "insertImage";
  static readonly INSERT_VID: string = "insertVideo";
  static readonly INSERT_HORZ_RULE: string = "insertHorizontalRule";
  static readonly TOGGLE_EDIT_MODE: string = "toggleEditorMode";
  static readonly BG_COLOR: string = "backgroundColor";
  static readonly JUSTIFY_LEFT: string = "justifyLeft";
  static readonly JUSTIFY_CENTER: string = "justifyCenter";
  static readonly JUSTIFY_RIGHT: string = "justifyRight";
  static readonly JUSTIFY_FULL: string = "justifyFull";
}

export const OFF_ACT_HIDDEN_BUTTONS: string[] = [
  EditorConfigConstants.FONT_NAME,
  EditorConfigConstants.CUSTOM_CLASSES,
  EditorConfigConstants.INSERT_IMG,
  EditorConfigConstants.INSERT_VID,
  EditorConfigConstants.INSERT_HORZ_RULE,
  EditorConfigConstants.TOGGLE_EDIT_MODE,
  EditorConfigConstants.BG_COLOR,
  EditorConfigConstants.JUSTIFY_LEFT,
  EditorConfigConstants.JUSTIFY_CENTER,
  EditorConfigConstants.JUSTIFY_RIGHT,
  EditorConfigConstants.JUSTIFY_FULL,
];

export class OfflineActivityConfigsValue {
  static readonly HEIGHT: string = "5rem";
  static readonly MIN_HEIGHT: string = "5rem";
  static readonly DEFAULT_FONTNAME: string = "Arial";
}

export const VOWELS = ["a", "e", "i", "o", "u"];

export class ExportConfig {
  static readonly ELEMENT_ID: string = "reportTable";
  static readonly EXPORT_ID: string = "exportTable";
  static readonly TEXT_HTML: string = "text/html";
  static readonly TEXT_CSV: string = "text/csv";
  static readonly APP_WORD: string = "application/msword";
  static readonly APP_PDF: string = "application/pdf";
  static readonly QUERY_SELECT_REPORT_TB: string =
    'mat-table[name="reportTable"]';
  static readonly LANDSCAPE: string = "landscape";
}

export const CHART_COLOR_SCHEME = {
  domain: ["#2a54a1", "#f6a417", "#34b3e7", "#fecf16", "#eb5f1a"],
};

export const CHART_ASSESSMENT_COLOR_SCHEME = {
  domain: [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
  ],
};
